/**
 * Get the user's preference for dark or light mode from the browser/OS.
 */
export const getOsPreferredTheme = () => {
    if (window.matchMedia) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'DARK';
        }
        if (window.matchMedia('(prefers-color-scheme: light)').matches) {
            return 'LIGHT';
        }
    }
    return undefined;
};
